import { render, staticRenderFns } from "./CommentReplies.vue?vue&type=template&id=99edf48e&scoped=true&"
import script from "./CommentReplies.vue?vue&type=script&lang=js&"
export * from "./CommentReplies.vue?vue&type=script&lang=js&"
import style0 from "./CommentReplies.vue?vue&type=style&index=0&id=99edf48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99edf48e",
  null
  
)

/* custom blocks */
import block0 from "./CommentReplies.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports